import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { signInPath } from '../utils/authNavigation';

// New accounts are created only after email verification and explicit consent.
export default function Signup() {
  const [params] = useSearchParams();
  return <Navigate to={signInPath(params.get('next'))} replace />;
}
